import { Money } from '@razz-team/ui-web';
import { ApiTransaction } from '../../../openapi';
import { memo } from 'react';

export const TransactionMoney = memo(function TransactionMoney({ trx }: { trx: ApiTransaction }) {
  const amount = trx.direction === 'IN' ? trx.origin.amount : trx.counterparty.amount;
  const value =
    trx.direction === 'IN' ? amount : { amount: amount.amount * -1, currency: amount.currency };

  let color = 'text.secondary';
  if (trx.state === 'COMPLETED') {
    color = trx.direction === 'IN' ? 'text.success' : 'text.primary';
  }

  return <Money withSign value={value} variant="h2" color={color} />;
});
